import React from 'react';
import { Route } from 'react-router-dom';
import { createProjectSteps } from '../constants/createProjectSteps';

export const createProjectRoutes = createProjectSteps.map(step => (
  <Route key={step.id} path={step.path} element={step.element} />
));
